import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { compressAndUpload } from "../../Helpers/Utils/photoUpload";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function ChargerDeliveryYesPage({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isUploading, setIsUploading] = useState(false);
  const [errors, setErrors] = useState({});

  const handlePhotoChange = async (e, fieldName) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Photo exceeds 5MB limit. Please retake the photo.", {
        autoClose: 3000, hideProgressBar: true, theme: "colored"
      });
      e.target.value = '';
      return;
    }

    setIsUploading(true);
    try {
      const uploadResult = await compressAndUpload(file);
      if (!uploadResult.success) {
        toast.error(uploadResult.error || "Upload failed. Please try again.");
        e.target.value = '';
        return;
      }
      setPrimaryDetails(prev => ({
        ...prev,
        [`${fieldName}_temp_path`]: uploadResult.temp_path
      }));
    } catch (error) {
      toast.error("Error uploading photo");
    } finally {
      setIsUploading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "file") return; // photos handled by handlePhotoChange
    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const validate = () => {
    const newErrors = {
      charger_case_no: !primaryDetails.charger_case_no,
      charger_request_photo: !primaryDetails.charger_request_photo_temp_path,
      charger_delivery_receipt: !primaryDetails.charger_delivery_receipt_temp_path,
    };

    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some(Boolean);
    
    if (hasErrors) {
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    return !!primaryDetails.charger_case_no &&
      !!primaryDetails.charger_request_photo_temp_path &&
      !!primaryDetails.charger_delivery_receipt_temp_path;
  };
  const handleSubmit = () => {
    if (validate()) {
      if (primaryDetails.maya_solution === 'Terminal') {
        // navigation.go('qrph-knowledge');
        navigation.go('merchandising');
      } else {
        navigation.go('maya-sqr-solution-details');
      }
    }
  };

  const handleBack = () => {
    navigation.previous();
  };



  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">CHARGER DELIVERY</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">

                <Form>
                {/* Charger Escalation Case No. */}
                  <Form.Label className="form-label">
                    Charger Escalation Case No. <span className="form-required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="charger_case_no"
                    value={primaryDetails.charger_case_no || ''}
                    onChange={handleChange}
                    placeholder="Enter escalation case number"
                    isInvalid={errors.charger_case_no}
                  />
                  {errors.charger_case_no && (
                    <div className="form-error">
                      Required
                    </div>
                  )}
                

                {/* Charger escalation request photo */}
                <Form.Group className="mb-4">
                  <Form.Label className="form-label">
                    Charger escalation request photo <span className="form-required">*</span>
                    {primaryDetails.charger_request_photo_temp_path && !isUploading && (
                      <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                    )}
                  </Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={(e) => handlePhotoChange(e, 'charger_request_photo')}
                    isInvalid={errors.charger_request_photo}
                    disabled={isUploading}
                  />
                  {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                  {errors.charger_request_photo && (
                    <div className="form-error">Required</div>
                  )}
                  <div>
                    <p className="form-note-text">
                      <em>"Note: Can be Escalation from Maya App Help Center or by Email."</em>
                    </p>
                  </div>
                </Form.Group>

                {/* Signed charger delivery receipt */}
                <Form.Group className="mb-4">
                  <Form.Label className="form-label">
                    Signed charger delivery receipt <span className="form-required">*</span>
                    {primaryDetails.charger_delivery_receipt_temp_path && !isUploading && (
                      <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                    )}
                  </Form.Label>
                  <Form.Text className="form-hint">
                    Upload a photo of the signed charger delivery receipt
                  </Form.Text>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={(e) => handlePhotoChange(e, 'charger_delivery_receipt')}
                    isInvalid={errors.charger_delivery_receipt}
                    disabled={isUploading}
                  />
                  {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                  {errors.charger_delivery_receipt && (
                    <div className="form-error">Required</div>
                  )}
                </Form.Group>

                <div className="form-nav-btns">
                  <AppButton
                    onClick={handleBack}
                    variant="back"
                    className="form-btn variant-secondary"
                  >
                    ← Back
                  </AppButton>
                  <AppButton
                    onClick={handleSubmit}
                    variant="next"
                    className="form-btn variant-primary"
                    disabled={!isFormValid()}
                  >
                    Next →
                  </AppButton>
                </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ChargerDeliveryYesPage;
